import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const MODALS = {
  status: 'status',
  statusDelete: 'statusDelete',
  multicast: 'multicast',
  upload: 'upload',
  pages: 'pages',
  deleteMessage: 'deleteMessage',
  multiPatientInvitation: 'multiPatientInvitation',
  textSnippets: 'textSnippets',
  contact_info: 'contact_info',
  profile_personal: 'profile_personal',
  profile_clinic: 'profile_clinic',
  sessionsCreate: 'sessionsCreate',
  sessionsDetail: 'sessionsDetail',
  sessionsCancel: 'sessionsCancel',
  sessionsResend: 'sessionsResend',
  sessionsRemoveParticipant: 'sessionsRemoveParticipant',
  editProfileImage: 'editProfileImage',
  profile: 'profile',
  sharePatientContact: 'sharePatientContact',
  deleteContact: 'deleteContact',
  staff_type: 'staff_type',
  staff_member: 'staff_member',
  createSubcontact: 'createSubcontact',
  invitePhysician: 'invitePhysician',
  delete_staff_member: 'delete_staff_member',
  newPermanentLink: 'newPermanentLink',
  cancelScheduledCall: 'cancelScheduledCall',
  videoauswahl: 'videoauswahl',
  deleteSessionChatMessage: 'deleteSessionChatMessage',
  sessionChatDetail: 'sessionChatDetail',
  sessionChatCreate: 'sessionChatCreate',
  sessionChatLeave: 'sessionChatLeave',
  sessionChatRemove: 'sessionChatRemove',
  sessionChatRemoveParticipant: 'sessionChatRemoveParticipant',
  sessionChatDeleteMessages: 'sessionChatDeleteMessages',
  sessionChatDeleteSettings: 'sessionChatDeleteSettings',
  sessionChatSearch: 'sessionChatSearch',
  newMessage: 'newMessage',
  contactSearch: 'contactSearch',
  patientPermanentLink: 'patientPermanentLink',
  patientPermanentQRCode: 'patientPermanentQRCode',
  resend_invitation: 'resend_invitation',
  delete_invitation: 'delete_invitation',
  infoMaterialForPatients: 'infoMaterialForPatients',
  textSnippetsDelete: 'textSnippetsDelete',
  textSnippetsEdit: 'textSnippetsEdit',
  userTagsEdit: 'userTagsEdit',
  userTagsDelete: 'userTagsDelete',
  featureUpgradeSnippets: 'featureUpgradeSnippets',
  featureUpgradeSessionMeeting: 'featureUpgradeSessionMeeting',
  featureUpgradeSessionMeetingGroup: 'featureUpgradeSessionMeetingGroup',
  featureUpgradePhysicianStatus: 'featureUpgradePhysicianStatus',
  featureUpgradeMulticast: 'featureUpgradeMulticast',
  featureUpgradeStaffAssistant: 'featureUpgradeStaffAssistant',
  featureUpgradeStaffPhysician: 'featureUpgradeStaffPhysician',
  featureUpgradeChat: 'featureUpgradeChat',
  featureUpgradePam: 'featureUpgradePam',
  featureUpgrade: 'featureUpgrade',
  physicianPagesWidgetSettings: 'physicianPagesWidgetSettings',
  contactInvite: 'contactInvite',
  requestWidget: 'requestWidget',
  greetingMessageEdit: 'greetingMessageEdit',
  address: 'address',
  openingHours: 'openingHours',
  services: 'services',
  PHYSICIAN_STATUS_MODAL: 'physicianStatusModal',
  PATIENT_PROFILE_EDIT: 'patientProfileEdit',
  NEW_QUESTIONNAIRE: 'newQuestionnaire',
  autoResponseMessageEdit: 'autoResponseMessageEditModal',
  smsSettingsEdit: 'smsSettingsEdit',
};

const useIsModal = () => {
  const location = useLocation();
  const list = [
    'invitePatient=email',
    'invitePatient=sms',
    ...Object.values(MODALS).map(modal => `modal=${modal}`),
  ];

  const isModal = useMemo(
    () =>
      list.reduce((acc, cur) => {
        if (location.search.includes(cur)) return true;
        return acc;
      }, false),
    [location.search],
  );

  return { isModal, list };
};

export default useIsModal;
